import { render } from "./dol-upload.vue?vue&type=template&id=3a306a3d"
import script from "./dol-upload.vue?vue&type=script&lang=js"
export * from "./dol-upload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__